import React, { useEffect, useRef, useState } from 'react';
import { useMarketingTheme } from '../../contexts/MarketingThemeContext';
import './ThemePicker.css';

const ThemePicker: React.FC = () => {
  const { themeId, theme, themes, setThemeId } = useMarketingTheme();
  const [open, setOpen] = useState(false);
  const rootRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!open) return;
    const onPointer = (e: MouseEvent) => {
      if (!rootRef.current?.contains(e.target as Node)) setOpen(false);
    };
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', onPointer);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onPointer);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  return (
    <div className="theme-picker" ref={rootRef}>
      <button
        type="button"
        className="theme-picker-trigger"
        aria-haspopup="listbox"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
        title="Preview color themes"
      >
        <span className="theme-picker-swatches" aria-hidden="true">
          {theme.swatches.map((c) => (
            <span key={c} style={{ background: c }} />
          ))}
        </span>
        <span className="theme-picker-label">{theme.name}</span>
        <span className="theme-picker-caret" aria-hidden="true">
          ▾
        </span>
      </button>

      {open && (
        <div className="theme-picker-menu" role="listbox" aria-label="Color themes">
          <p className="theme-picker-hint">Preview themes for voice &amp; CX. Choice is saved locally.</p>
          {themes.map((t) => (
            <button
              key={t.id}
              type="button"
              role="option"
              aria-selected={t.id === themeId}
              className={`theme-picker-option ${t.id === themeId ? 'is-selected' : ''}`}
              onClick={() => {
                setThemeId(t.id);
                setOpen(false);
              }}
            >
              <span className="theme-picker-option-swatches" aria-hidden="true">
                {t.swatches.map((c) => (
                  <span key={c} style={{ background: c }} />
                ))}
              </span>
              <span className="theme-picker-option-text">
                <strong>{t.name}</strong>
                <span>{t.tagline}</span>
                <em>{t.why}</em>
              </span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default ThemePicker;
